module.exports = __webpack_public_path__ + "img/traffic-line.7184fc46.svg";